import React, {useState, useEffect, useRef, useMemo} from 'react';
import Head from 'next/head';
import styled from 'styled-components';

import PageWrapper from 'components/pageWrapper';
import BlockHeaderWhiteBox from 'components/blocks/blockHeaderWhiteBox';
import ContentArea from 'components/contentArea';


import seo from 'utils/seo'

import storyblokService from 'services/storyblokService.js'


import {date as dateLens} from 'utils/lenses';
const lenses = {date:dateLens};


const Page = (props) => {

  // Get content from supplied StoryBlok story
  const content = useMemo(() => {
    return props.pageData?.content;
  }, [props.pageData])

  const seoContent = content.seo;

  return (

    <>

      <Head>
        <title>{seo.createTitle(seoContent?.title)}</title>
        <meta name="description" content={seoContent?.description} />
      </Head>

      <StyledPage className="homePage">

          <PageWrapper>
              <BlockHeaderWhiteBox block={{
                  header_image: content.image,
                  title: content.title,
                  subtitle: lenses.date(content.date),
                  header_alt_text: content.image_alt_text
              }} />
              <ContentArea content={content.content} />
          </PageWrapper>

      </StyledPage>
        
      {storyblokService.bridge()}

    </>
  
  ); 

}


export default Page;



// Styles
const StyledPage = styled.div``;



